import type { TabDefinition } from '@shared/components';

export type AgreementTab = 'overview' | 'customer' | 'financials' | 'history' | 'notes' | 'documents' | 'invoicing' | 'manage';

const AGREEMENT_TABS: TabDefinition<AgreementTab>[] = [
    { id: 'overview', label: 'Overview' },
    { id: 'invoicing', label: 'Invoicing' },
    { id: 'customer', label: 'Customer' },
    { id: 'financials', label: 'Financials' },
    { id: 'history', label: 'History' },
    { id: 'notes', label: 'Notes' },
    { id: 'documents', label: 'Documents' },
    { id: 'manage', label: 'Manage agreement' },
];

export interface TabPermissions {
    canBrowseNotes: boolean;
    canBrowseDocuments: boolean;
    canAddInvoice: boolean;
    canManage?: boolean;
}

export function visibleAgreementTabs({ canBrowseNotes, canBrowseDocuments, canAddInvoice, canManage = false }: TabPermissions): TabDefinition<AgreementTab>[] {
    return AGREEMENT_TABS.filter(
        (tab) =>
            (tab.id !== 'notes' || canBrowseNotes) &&
            (tab.id !== 'documents' || canBrowseDocuments) &&
            (tab.id !== 'invoicing' || canAddInvoice) &&
            (tab.id !== 'manage' || canManage),
    );
}

/** A selected or returned-to tab the caller cannot see falls back to Overview. */
export const resolveActiveTab = (selected: AgreementTab, tabs: readonly TabDefinition<AgreementTab>[]): AgreementTab =>
    tabs.some((tab) => tab.id === selected) ? selected : 'overview';
